export default {
  title: "Filtros",
  buttons: {
    gotoModules: "Modulos"
  },
  labels: {
    search: "Buscar por nombre",
    select: "Escoge un Equipo",
    maintenance: "Mantenimiento",
    repair: "Reparación",
    reliability: "Confiabilidad",
    onetime: "Tareas Única",
    recurrent: "Tareas Periódicas",
    future: "Mostrar tareas futuras",
    old: "Mostrar tareas pasadas",
    none: "Ninguno"
  }
};
